import * as React from "react";
import {Fragment} from "react";
import {Col, Input, Row} from "reactstrap";

export default class QuotationResponseComponent extends React.Component {

    constructor(props) {
        super(props);

        this.className = this.props.className;

        this.state = {
            quotationResponse: this.props.quotationResponse || {}
        }
    }

    componentDidMount() {

        if (this.props.setHeader)
            this.props.setHeader();
    }

    render() {

        return <Fragment>
            <div className={this.className + "_quote_display"}>
                <div style={{padding: "0 0 35px 0", display: "flex"}}>
                    <div style={{flex: "2"}}>
                        <Input disabled={true} className={this.className + "_amount_bubble"} style={{color: "#41990e"}}
                               value={"R " + this.state.quotationResponse.total}/>
                    </div>
                    <div style={{flex: "1", textAlign: "center", margin: "auto"}}>
                        <div style={{fontSize: "18px"}} className={"fa fa-arrow-right"}/>
                    </div>
                    <div style={{flex: "2"}}>
                        <Input disabled={true} className={this.className + "_amount_bubble"} style={{color: "#575957"}}
                               value={this.state.quotationResponse.destinationCurrency + " " + this.state.quotationResponse.destinationAmount}/>
                    </div>
                </div>

                <Row className={this.className + "_quote_display_row"} style={{padding: "0 30px 0 30px"}}>
                    <Col xs={8}>
                        <Row style={{fontWeight: "bold"}}>ZAR/{this.state.quotationResponse.destinationCurrency}: </Row>
                        <Row style={{fontWeight: "bold"}}>VAT: </Row>
                        <Row style={{fontWeight: "bold"}}>Transaction Charges: </Row>
                        <Row style={{fontWeight: "bold"}}>Total To Pay: </Row>
                    </Col>
                    <Col xs={4}>
                        <Row
                            className={this.className + "_quote_values"}>{this.state.quotationResponse.effectiveRate} </Row>
                        <Row className={this.className + "_quote_values"}>R {this.state.quotationResponse.vat} </Row>
                        <Row className={this.className + "_quote_values"}>R {this.state.quotationResponse.fees} </Row>
                        <Row className={this.className + "_quote_values"}>R {this.state.quotationResponse.total} </Row>
                    </Col>
                </Row>
            </div>

        </Fragment>
    }

}